import { FC } from 'react';
import { type ObjectiveMedia } from '@teachur/http-client';

interface MediaInfoProps {
  objectiveName?: string;
  media: ObjectiveMedia;
}

export const MediaInfo: FC<MediaInfoProps> = ({ objectiveName, media }) => {
  return (
    <div className="space-y-2">
      {objectiveName && (
        <p className="[font-size:var(--font-l3)] lg:[font-size:var(--font-p2)] m-0!">
          <span className="font-semibold">Objective:</span> {objectiveName}
        </p>
      )}
      <p className="[font-size:var(--font-l3)] lg:[font-size:var(--font-p2)] m-0! text-[#2B383B]">
        <span className="font-semibold">Media Description:</span>{' '}
        {media.description || 'No description'}
      </p>
    </div>
  );
};
